import { render, staticRenderFns } from "./DossierItem.vue?vue&type=template&id=398c0f59&scoped=true&"
import script from "./DossierItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierItem.vue?vue&type=style&index=0&id=398c0f59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c0f59",
  null
  
)

export default component.exports